import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useAccount, State } from "@grandvisionhq/auth";
import { Text } from "@grandvisionhq/elements";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
/* empty css                */
import { mapCartDataToExpressInit } from "../../../../../../../../mappers/analytics/data-layer/mappers/analytics/data-layer/express-init-mapper.js";
import { ExpressActionContainer } from "../../../../../../containers/ExpressActionContainer/modules/Summary/containers/ExpressActionContainer/ExpressActionContainer.js";
import { FixCartButtonContainer } from "../../../../../../containers/FixCartButtonContainer/modules/Summary/containers/FixCartButtonContainer/FixCartButtonContainer.js";
import { useCart } from "../../../../../../../../context/Cart/context/Cart/context.js";
const Navigation = ({
  labels,
  unavailableLineItems,
  hasSubscription,
  handleCheckoutNavigation
}) => {
  const { isMyAccountEnabled } = useFeatureToggles();
  const authState = useAccount();
  const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn;
  const [{ cartId }] = useCartStorage();
  const { cart } = useCart();
  const [isOrderInProgress, setIsOrderInProgress] = React.useState(false);
  const { getLabel } = useIntl();
  const handleInitExpressDataLayerEvent = React.useCallback(
    (paymentMethod) => {
      if (cart && authState) {
        const eventData = mapCartDataToExpressInit(cart, paymentMethod, isLoggedIn);
        DataLayer.pushEcommerceEvent(eventData);
      }
    },
    [cart, authState, isLoggedIn]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "cart-navigation" }, /* @__PURE__ */ React.createElement("div", { className: "checkout-button-container" }, !unavailableLineItems?.length && cartId && /* @__PURE__ */ React.createElement(React.Fragment, null, isOrderInProgress && /* @__PURE__ */ React.createElement(Text, { className: "payment-form-container__instruction" }, getLabel(`checkout.express.payment.wait.instruction`)), !isOrderInProgress && /* @__PURE__ */ React.createElement(
    ExpressActionContainer,
    {
      hasSubscription,
      isOrderInProgress,
      setIsOrderInProgress,
      onClickHandler: handleInitExpressDataLayerEvent
    }
  )), !isOrderInProgress && /* @__PURE__ */ React.createElement(
    FixCartButtonContainer,
    {
      handleCheckoutNavigation,
      labels,
      unavailableLineItems,
      isLoggedIn
    }
  )));
};
export {
  Navigation
};
//# sourceMappingURL=Navigation.js.map
